import React, { useEffect, useState } from 'react'
import useStyles from '../styles/main_calculator';



const MainCalculatorContainer: React.FC = () => {
      // window.open('www.xxx.com', '_blank', 'width=300,height=400')
  // window.open('Calculator:///');
    


  return (
        <main>
            <h1>Fucker</h1>
        </main>
  )
}

export default MainCalculatorContainer
